// Cookie handling:
// https://www.npmjs.com/package/vue-cookie

import router from '../router'
import store from '../store'
import { getUserFromLoginObject } from "../user"

var cookie = require('vue-cookie')

export default {
    login: function (username, data) {

        var user = getUserFromLoginObject(data);
        user.email = username;
        store.commit("login", user);

        cookie.set("token", 'Token ' + data.token);
        cookie.set("user", JSON.stringify(store.state.user));
        cookie.set("token_expires", data.expires);

        router.push("/");
    },

    logout: function () {
        store.dispatch("logout");

        cookie.delete('token');
        cookie.delete('user');
        cookie.delete('context');
        cookie.delete('token_expires');

        router.push("/");
    },

    restore: function () {
        try {

            var auth = cookie.get('token');
            var user = cookie.get('user');
            var lang = cookie.get('lang');
            var expires = cookie.get('token_expires');

            if(lang && lang.length === 2)
                store.dispatch("setLanguage", lang);

            if(this.isInFuture(expires))
            {
                if (user && auth) {
                    store.commit("restore", JSON.parse(user));

                    // Restore context
                    var context = cookie.get('context');
                    var parsedContext = (context ? JSON.parse(context) : false);

                    if (parsedContext && parsedContext['id'] > 0)
                        store.commit("setContext", parsedContext);
                }
            }
        } catch (error) {
            return;
        }
    },

    getAuthHeader: function () {
        return cookie.get('token');
    },

    isInFuture: function (token) {
        let date = new Date(token);
        let now = new Date()
        return now <= date;
    }
}


// WEBPACK FOOTER //
// ./src/utils/auth.js